import { atom } from 'recoil';
import { getDogUseListSelector } from '../selectors/getDogUseListSelector';
import { type DogUseDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/pet';

export const dogUseListAtom = atom<DogUseDTO[]>({
    key: 'dogUseList',
    default: getDogUseListSelector
});
